<template>
  <div class="adstatsdetail">
    <h2 class='title is-5'>Detail for {{ $parent.expandLocation($route.params.loc) }}</h2>
    <table class='table is-bordered is-striped is-hoverable'>
      <tbody>
      <tr v-for="(d, idx) in data" v-bind:key="idx">
        <th>{{ d.sku }}</th>
        <td>{{ d.total_hits }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name : 'adstatsdetail',
  data : function(){
    return {
      data : []
    }
  },
  watch : {
    '$route'(to, from){
      if(to.params.loc !== from.params.loc){
        this.getData();
      }
    }
  },
  mounted(){
    this.getData();
  },
  methods : {
    getData : function(){
      this.callAPI('get', `adstats/${this.$route.params.loc}`)
        .then((res) => {
          this.data = res.data.stats;
        })
        .catch((err) => { console.error(err); });
    }
  }
};
</script>